import { Create } from '@fund/api-modules';
import { getApiHostWithoutEnv } from '@fund/api-host';
import axios from 'axios';
import CreateByUser from './decorator/CreateByUser';
import FundManagerModel from '../model/fundmanager.model';
import DividendModel from '../model/dividend.model';
import NoticeModel from '../model/announcement.model';
import TransformResponse from './decorator/TransformResponse';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken,
      ctoken,
      uid,
      deviceid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      version: '6.5.5',
      customerNo: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})

@Create({
  baseURL: getApiHostWithoutEnv('fundmobapi'), // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'web',
  },
})

class Quotation {
  // 获取公告信息
  @TransformResponse((res) => NoticeModel.objectArrayWithKeyValuesArray(res.Datas || []))
  getFundMNNoticeList(FCODE) {
    // https://fundmobapi.eastmoney.com/FundMNewApi/FundMNNoticeList?FCODE=000001&pageIndex=1&pagesize=30&scene=detail&deviceid=EABB8E88-FD9D-4932-8F9D-FC262FC0BFD8&plat=Iphone&product=EFund&version=6.2.5&GTOKEN=3C39409521AE467B857E194D70BA5Ae1
    return this.GET('/FundMNewApi/FundMNNoticeList', {
      FCODE,
      pageIndex: 1,
      pagesize: 2,
      scene: 'detail',
    });
  }

  // 获取分红配送信息
  @TransformResponse((res) => {
    if (res.Datas) {
      return DividendModel.objectWithKeyValues(res.Datas || {});
    }
    return DividendModel.objectWithKeyValues({});
  })
  getFundMNBonusDetail(FCODE) {
    // https://fundmobapi.eastmoney.com/FundMNewApi/FundMNBonusDetail?FCODE=000001&deviceid=EABB8E88-FD9D-4932-8F9D-FC262FC0BFD8&plat=Iphone&product=EFund&version=6.2.5&GTOKEN=3C39409521AE467B857E194D70BA5Ae1
    return this.GET('/FundMNewApi/FundMNBonusDetail', {
      FCODE,
    });
  }

  // 获取基金经理信息
  @TransformResponse((res) => FundManagerModel.objectArrayWithKeyValuesArray(res.Datas || []))
  getFundMNMangerList(FCODE) {
    // https://fundmobapi.eastmoney.com/FundMNewApi/FundMNMangerList?FCODE=000001&deviceid=EABB8E88-FD9D-4932-8F9D-FC262FC0BFD8&plat=Iphone&product=EFund&version=6.2.5&GTOKEN=3C39409521AE467B857E194D70BA5Ae1
    return this.GET('/FundMNewApi/FundMNMangerList', {
      FCODE,
    });
  }

  getNetList(item) {
    return this.GET('/FundMNewApi/FundMNHisNetList', {
      FCODE: item.id,
      IsShareNet: item.isShareNet,
    });
  }

  getNewFundStartTimeList(FCODE) {
    return this.GET('/market/fetchFundDynamicInfo', {
      fundCode: FCODE,
    }, {
      baseURL: 'https://mobilesub.1234567.com.cn/basedata',
    });
  }

  getFundMNStopWatch(FCODE) {
    return this.GET('/FundMNewApi/FundMNStopWatch', {
      FCODE,
    });
  }

  getPeriodIncrease(FCODE) {
    return this.GET('/FundMNewApi/FundMNPeriodIncrease', { FCODE });
  }

  getFundMNBasicInfoWarinfo(FCODE) {
    return this.GET('/FundMNewApi/FundMNBasicInfoWarinfo', { FCODE, ISABNORMAL: 'true' });
  }

  getFundMainInfo(FCODE) {
    const mainurl = `/sc/tfs/qt/v2.0.1/${FCODE}.json`;
    const curTime = new Date().getTime();
    return this.GET(mainurl, { curTime }, {
      baseURL: 'https://j5.fund.eastmoney.com',
    });
  }

  // 容灾
  getFundMainInfo2(FCODE) {
    const mainurl = `/sc/tfs/qt/v3.0.1/${FCODE}.json`;
    const curTime = new Date().getTime();
    return this.GET(mainurl, { curTime }, {
      baseURL: 'https://j5.dfcfw.com',
    });
  }

  getFundMNNBasicInformation(FCODE) {
    console.log(this);
    const baseURL = getApiHostWithoutEnv('fundmobapi');
    const mainurl = `${baseURL}/FundMNewApi/FundMNNBasicInformation`;
    return new Promise((resolve, reject) => {
      axios.get(mainurl, {
        params: {
          FCODE,
        },
      })
        .then((json) => {
          resolve(json);
        })
        .catch((error) => reject(error));
    });
  }

  getFundMNNBasicInformationQH(FCODE) {
    console.log(this);
    const mainurl = `https://j5.fund.eastmoney.com/sc/tfs/qt/v2.0.1/${FCODE}.json`;
    return new Promise((resolve, reject) => {
      axios.get(mainurl, {
        params: {
          FCODE,
        },
      })
        .then((json) => {
          resolve(json);
        })
        .catch((error) => reject(error));
    });
  }

  getFundMNAssetAllocationNew(FCODE) {
    return this.GET('/FundMNewApi/FundMNAssetAllocationNew', { FCODE });
  }

  getFundMNPZKGZH(FCODE) {
    return this.GET('FundMNewApi/FundMNPZKGZH', { SortColumn: 'SYL_3Y', Sort: 'desc', FCODE });
  }

  getFundMNInverstPosition(FCODE) {
    return this.GET('FundMNewApi/FundMNInverstPosition', { FCODE });
  }

  getFundMNInverstPositionNew(FCODE) {
    return this.GET('FundMNewApi/FundMNInverstPositionNew', { FCODE });
  }

  getFundMNInvestMoneyManagement(FCODE) {
    return this.GET('FundMNewApi/FundMNInvestMoneyManagement', { FCODE });
  }

  getFundInfo(FCODE) {
    return this.JSONP('FundMApi/FundInfo.ashx', { FCODE });
  }

  getFundMNBonusPoints(FCODE) {
    return this.GET('FundMNewApi/FundMNBonusPoints', {
      FCODES: FCODE,
    });
  }

  getFundMNTagList(FCODE) {
    return this.GET('FundMNewApi/FundMNTagList', {
      FCODE,
    });
  }
}

const quotation = new Quotation();

export default quotation;
